import { DataPackCalendarPeriod } from '../../app/models/dataPackCalendarPeriod.model';

/**
 * @version $Id: dataPackCalendar.model.ts 79367 2018-02-17 00:41:28Z thiago.h.neri $
 */
export class DataPackCalendar {

  public id: number;
  public description: string;
  public descriptionOld: string;
  public initialDate: string;
  public endDate: string;
  public info1: string;
  public info2: string;
  public info3: string;
  public info4: number;
  public info5: number;
  public businessHour: boolean;
  public detailed: boolean;
  public periods: Array<DataPackCalendarPeriod>;
  public allPeriods: Array<DataPackCalendarPeriod>;

  public constructor() {

  }
}


// WEBPACK FOOTER //
// ./src/app/models/dataPackCalendar.model.ts